import React, { Component } from 'react'
import { apiInstance } from '../../actions/http';


const formhoc = (WrappedComponent, inputs = [], formConfig={}) => {

    const initialState = formState(inputs);

    return class Form extends Component {

        constructor(props){
            super(props);
            this.state = {
                ...initialState,
                form_fetching: false,
                form_err: false,
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
        }

        //handle input change
        handleChange(e){
            const { name, value } = e.target;
            this.setState({
                [name]: value,
                [name + "_err"]: ''
            });
        }

        //validate form
        validForm = (ips) => {
            for(let i =0; i < ips.length; i++ ){
                const ip = ips[i];
                const ipValue = this.state[ip.name];
                if(!ip.optional && !ipValue){
                    this.setState({
                        [ip.name + "_err"]: "This field is required"
                    });
                    return false;
                }
                if(ip.validate){
                    switch(ip.validate.type){
                        case "PHONE_NUMBER":
                            if(!phonevalid(ipValue)){
                                this.setState({
                                    [ip.name + "_err"]: "Phone number is invalid"
                                });
                                return false;
                            } 
                            break;
                        case "EMAIL":
                            if(!emailvalid(ipValue)){
                                this.setState({
                                    [ip.name + "_err"]: "Email is invalid"
                                });
                                return false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            }
            return true;
        }

        //check if form is filled
        checkinputs = () =>{
            for(let i =0; i < inputs.length; i++ ){
                const ip = inputs[i];
                const ipValue = this.state[ip.name];
                if(!ip.optional){
                    if(!ipValue){
                        return false;
                    }
                }
            }
            return true;
        }

        //handle submit
        async handleSubmit(e){
            e.preventDefault();
            if(!this.validForm(inputs)){
                return false;
            }
            const data = this.createPostdata();
            this.setState({form_fetching: true});
            try {
                await apiInstance({
                    ...formConfig, data
                });
                this.setState({form_fetching: false, ...initialState});
            } catch (err){
                this.setState({form_fetching: false});
                console.log(err);
            }
        }

        createPostdata = () => {
            let postData = {};
            for(let i = 0; i < inputs.length; i++ ){
                const ip = inputs[i];
                postData[ip.name] = this.state[ip.name];
            }
            return postData;
        }

        render() {
            const formFilled = this.checkinputs();
            return (
                <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
                    <WrappedComponent 
                        ipState={this.state}
                        onChange={this.handleChange}
                        formFilled={formFilled}
                        {...this.props}
                    />
                </form>
            )
        }
    }  
}

export const formState = (ips) => {
    let state = {};
    ips.forEach(ip => {
        state[ip.name] = ip.defaultValue || '';
        state[ip.name + "_err"] = '';
    })
    return state;
}   

export const emailvalid = val => {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(val);
}

export const phonevalid = val => {
    var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return re.test(val);
}

export const pwdvalid = val => {
    return val.length > 5;
}

export default formhoc